import React from "react";
import SweetAlert from 'react-bootstrap-sweetalert';

export default (props) => {
  const {
    inputProps,
    onConfirm,
    onCancel
  } = props;
  const { type, show} = inputProps;

  let title = "Опубликовать все"; 
  if(type === "error") title = "Ошибка";
  if(type === "success") title = "Опубликовано успешно!"; 

  return (
    <SweetAlert
      style={{overflow:'unset'}}
      type={type}
      confirmBtnCssClass="alert-btn-confirm"
      cancelBtnCssClass="alert-btn-cancel"
      showCancel
      showConfirm={type === "default" ? true : false}
      show={show}
      confirmBtnText="Продолжить"
      cancelBtnText={type === "default" ? "Отменить" : "Готово"}
      confirmBtnBsStyle="danger"
      cancelBtnBsStyle="default"
      title={title}
      onConfirm={type === "success" ? () => onCancel() : () => onConfirm()}
      onCancel={onCancel}
    >
      <div>
        <span>
          Публиковаться будут все результаты, цена подсчитывается автоматически.
        </span>
      </div>
    </SweetAlert>
  )
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/Modals/PublishAllResults.js